// tslint:disable-next-line:no-unused-expression
export enum AppEnums {
    CurrentUser = 'user',
    SelectedStore = 'store',
    SavedOrder = 'savedOrder'

}

export enum AppEnumsSession {
    trackingId = 'trackingId',
    SelectedStore = 'store',
    orderStatus = 'orderStatus',
    cartCount = 'cartCount'
}
